import { changeHomeHistory, loadFolderSuccess } from 'reactApp/modules/home/home.actions';
import { isFileInCurrentFolder } from 'reactApp/modules/modifying/modifying.helpers';
import { routerStart } from 'reactApp/modules/router/router.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { scrollToItemAction } from 'reactApp/modules/storage/storage.module';
import { folderCloudPath } from 'reactApp/modules/uploadList/uploadList.helpers';
import { call, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';

import { resetSelect, scrollToHomeItemAction, setScrollToItemState } from './selections.actions';
import { SelectionsSelectors } from './selections.selectors';

export function* resetSelected() {
    const selected = yield select(SelectionsSelectors.getSelectedIdxs);

    if (!selected.length) {
        return;
    }

    yield put(resetSelect());
}

function* scrollToItem({ payload }: ReturnType<typeof scrollToHomeItemAction>) {
    const storage = yield select(getCurrentStorage);
    const { isReactPage, isPublic } = getStorage(storage);

    if (!isReactPage && !isPublic) {
        return;
    }

    const { isFolder, itemId = '', parentFolderId } = payload;
    const fileInCurrentFolder = yield call(isFileInCurrentFolder, itemId);
    const folderIdByPath = yield call(folderCloudPath, itemId);
    const folderId = parentFolderId || folderIdByPath;

    let pathToItem = '';

    if (isFolder && itemId) {
        pathToItem = itemId;
    } else if (!fileInCurrentFolder || !itemId) {
        pathToItem = folderId;
    }

    if (pathToItem) {
        yield put(setScrollToItemState({ itemId, needScroll: true }));
        yield put(changeHomeHistory({ id: pathToItem }));
    } else {
        yield put(scrollToItemAction(itemId));
    }
}

function* routeChange() {
    const scrollToItemState = yield select(SelectionsSelectors.getScrollToItemState);

    if (scrollToItemState.needScroll) {
        yield take(loadFolderSuccess);

        yield put(scrollToItemAction(scrollToItemState.itemId));
        yield put(setScrollToItemState({ itemId: '', needScroll: false }));
    }
}

export function* watchSelections() {
    yield takeLatest(scrollToHomeItemAction.toString(), scrollToItem);
    yield takeEvery(routerStart.toString(), routeChange);
}
